import React, { Component } from "react";
import "./Alternative.css";
import Cookie from 'js-cookie';
import {
    message, ConfigProvider, Divider,
    Table, Empty, Spin,
    Button,
    Steps, Row, Col
} from 'antd';
import { Link } from "react-router-dom";


export default class InvitedAlternative extends Component {
    constructor(props) {
        super(props);

        this.state = {
            email: Cookie.get("email"),
            projectAlternatives: [],
            loading: true, //the loading status default true
            projectName: "",
            projectEvaluationType: "",
            role: ""
        };
    }

    onStepChange = current => {
        if(current === 1){
            this.props.history.push(`/invitedcriteria/${this.props.match.params.projectid}/${this.props.match.params.actorid}`)
        }
        if(current === 2){
            this.props.history.push(`/invitedweight/${this.props.match.params.projectid}/${this.props.match.params.actorid}`)
        }
        if(current === 3){
            this.props.history.push(`/invitedevaluation/${this.props.match.params.projectid}/${this.props.match.params.actorid}`)
        }
        if(current === 4){
            this.props.history.push(`/invitedmamcaresult/${this.props.match.params.projectid}/${this.props.match.params.actorid}`)
        }
    }

    //get the alternatives
    getProjectAlternatives = () => {
        fetch(`/invitedProject/getInvitedProject/${this.props.match.params.projectid}/${this.props.match.params.actorid}/${Cookie.get("email")}/`, { //get the project id from link
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            },
        }).then(res => res.json())
            .then(json => {
                if (json.success) {
                    this.setState({
                        projectAlternatives: json.project.projectAlternatives,
                        projectName: json.projectName,
                        projectEvaluationType: json.projectEvaluationType,
                        role: json.role,
                        loading: false
                    }) //save project data
                }
                else {
                    message.error(json.message)
                    this.props.history.push("/"); //redirect to homepage if the project not exist, shouldn't be a case
                }
            });
    }

    checkDisable(){
            if(this.state.projectAlternatives.length<2){
              return true
            }
            else{
              return false
            }
      }

    componentDidMount() {
        try {
            this.getProjectAlternatives() //after render immediately get alternative list
        } catch (e) {
            alert(e);
        }
    }

    render() {
        const Step = Steps.Step;
        //the step infomation
        const mcaSteps = [{
            title: 'Alternatives',
        }, {
            title: 'Criteria',
        }, {
            title: 'Weights',
        }, {
            title: 'Evaluation',
        }, {
            title: 'Result',
        }];
        const columns = [{ //the column title of the table
            title: 'Alternative Name', //the title of column
            dataIndex: 'alternativeName', //the data index can be used for searching, filtering
            key: 'alternativeName',
            width: '50%',
        },
        {
            title: 'Alternative Description',
            dataIndex: 'alternativeDescription', 
            key: 'alternativeDescription',
            width: '50%',
        }];
        return <div className="Alternative">
            <Spin size="large" tip="Loading..." spinning={this.state.loading}>
                <Row style={{ marginTop: "5vh" }} type="flex" justify="space-around">
                    <Col span={4}>
                        <h4>Project name: {this.state.projectName}</h4>
                    </Col>
                    <Col span={4}>
                        <h4>Evaluation type: {this.state.projectEvaluationType}</h4>
                    </Col>
                    <Col span={4}>
                        <h4>Role: {this.state.role}</h4>
                    </Col>
                </Row>
                <Divider />
                <Steps style={{ width: "80%", margin: "auto" }} current={0} onChange={this.onStepChange}>
                    {mcaSteps.map(item => <Step key={item.title} title={item.title} />)}
                </Steps>
                <div className="steps-content"></div>
                <ConfigProvider renderEmpty={() => { return (<Empty />); }}>
                    <Table columns={columns}
                        rowKey={record => record._id} //unique key needed, so we use mongodb id
                        dataSource={this.state.projectAlternatives} //the data source is what we get after component mount
                    />
                </ConfigProvider>
                <Divider />
                <div className="steps-action">
                {/* disabled={this.checkDisable(this.state.project)} */}
                <Button size="large" type="primary" >
                <Link to={`/invitedcriteria/${this.props.match.params.projectid}/${this.props.match.params.actorid}`}>Next</Link></Button>
                </div>
            </Spin>
        </div>;
    }
}